import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import '../assets/css/style2.css';
import '../assets/css/globalStyles.css';

// Image imports
import roomGallery04 from '../assets/images/rooms/room-gallery04.webp';
import roomGallery03 from '../assets/images/rooms/room-gallery03.webp';
import roomGallery02 from '../assets/images/rooms/room-gallery02.webp';
import roomGallery01 from '../assets/images/rooms/room-gallery01.webp';
import sideGallery01 from '../assets/images/side-gallery01.webp';
import sideGallery02 from '../assets/images/side-gallery02.webp';
import sideGallery03 from '../assets/images/side-gallery03.webp';
import logoTripadviser from '../assets/images/logo-tripadviser.png';
import slider from '../assets/images/rooms/slider.webp';
import icon01 from '../assets/images/rooms/icon01.png';
import icon03 from '../assets/images/rooms/icon03.png';
import icon04 from '../assets/images/rooms/icon04.png';
import icon05 from '../assets/images/rooms/icon05.png';
import icon07 from '../assets/images/rooms/icon07.png';
import icon08 from '../assets/images/rooms/icon08.png';
import icon09 from '../assets/images/rooms/icon09.png';
import icon10 from '../assets/images/rooms/icon10.png';
import icon11 from '../assets/images/rooms/icon11.png';
import icon12 from '../assets/images/rooms/icon12.png';

// Components
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Accommodation = () => {
  // Script for changing navbar background on scroll
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY;
      const navbar = document.querySelector('.navbarzzz');
      if (navbar) {
        if (scroll > 0) {
          navbar.style.backgroundColor = '#722628';
        } else {
          navbar.style.backgroundColor = 'transparent';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="example">
      <Helmet>
              <meta charset="utf-8" />
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1, shrink-to-fit=no"
              />
              <meta name="theme-color" content="#722628" />
              <title>
              Rooms & Suites| Boutique Hotels and Leisure, Sri Lanka | Oryza
                Leisure
              </title>
              <meta name="author" content="Ollcode" />
              <meta name="description" content="Beautiful Luxury and Cosy stay at Kent Cottage Nuwara-Eliya" />
              <meta name="keywords" content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, penthouse, vip" />

            </Helmet>
      <div className="cursor js-cursor"></div>
      <Navbar />
      <main id="main">
        <header className="page-header" style={{ backgroundImage: `url(${slider})` }}>
          <div className="container">
            <h1>ROOMS & SUITES</h1>
            <p>Immersion into Well-being</p>
          </div>
          <div className="scroll-down"></div>
        </header>

        <section className="content-section kentbg paddingb">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ul className="rooms-list">
                  <li>
                    <div className="room-box">
                      <figure className="reveal-effect wow">
                        <a href="/kent/room-loftsuite">
                          <img src={roomGallery04} alt="gallery4" />
                        </a>
                      </figure>
                      <div className="content">
                        <div className="sub-text">VIEW MORE DETAILS ABOUT</div>
                        <h3><a href="/kent/room-loftsuite">Loft Suite</a></h3>
                        <p>Our deluxe king suite brings the tender feeling of home with the opulence of luxury together. It boasts a chic, modern look, balanced by vintage fixtures and details, then rounded out with a jacuzzi tub that adds a splash of romance.</p>
                        <div className="bottom-specs">
                          <div className="icons">
                            <img src={icon01} alt="Large Double Bed" />
                            <img src={icon10} alt="Heater" />
                            <img src={icon03} alt="In-house Dining" />
                            <img src={icon04} alt="Wifi" />
                            <img src={icon08} alt="Jacuzzi" />
                            <img src={icon07} alt="Television" />
                            <img src={icon11} alt="Hill View" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="room-box">
                      <figure className="reveal-effect wow">
                        <a href="/kent/room-masterroom">
                          <img src={roomGallery03} alt="gallery3" />
                        </a>
                      </figure>
                      <div className="content">
                        <div className="sub-text">VIEW MORE DETAILS ABOUT</div>
                        <h3><a href="/kent/room-masterroom">Master Room</a></h3>
                        <p>The master bedroom feels regal, thus, is perfect for a holiday where self-care and tranquillity are top priority. Designed with rich elegance, the bathroom is fitted with a majestic vintage bathtub for a relaxing stay.</p>
                        <div className="bottom-specs">
                          <div className="icons">
                            <img src={icon01} alt="Large Double Bed" />
                            <img src={icon10} alt="Heater" />
                            <img src={icon03} alt="In-house Dining" />
                            <img src={icon04} alt="Wifi" />
                            <img src={icon05} alt="gallery" />
                            <img src={icon07} alt="Television" />
                            <img src={icon12} alt="Garden View" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="room-box">
                      <figure className="reveal-effect wow">
                        <a href="/kent/room-doubleroom">
                          <img src={roomGallery02} alt="gallery4" />
                        </a>
                      </figure>
                      <div className="content">
                        <div className="sub-text">VIEW MORE DETAILS ABOUT</div>
                        <h3><a href="/kent/room-doubleroom">Deluxe Double Room</a></h3>
                        <p>If you're in to the classics, then this is the room for you. Decorated in a brilliant royal blue, this room feels luxurious with hints of home. A gorgeous king-sized bed with a built-in television for an extra cosy day in.</p>
                        <div className="bottom-specs">
                          <div className="icons">
                            <img src={icon01} alt="Large Double Bed" />
                            <img src={icon10} alt="Heater" />
                            <img src={icon03} alt="In-house Dining" />
                            <img src={icon04} alt="Wifi" />
                            <img src={icon07} alt="Television" />
                            <img src={icon12} alt="Garden View" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="room-box">
                      <figure className="reveal-effect wow">
                        <a href="/kent/room-twinroom">
                          <img src={roomGallery01} alt="gallery4" />
                        </a>
                      </figure>
                      <div className="content">
                        <div className="sub-text">VIEW MORE DETAILS ABOUT</div>
                        <h3><a href="/kent/room-twinroom">Deluxe Twin Room</a></h3>
                        <p>The twin room shines as the cutest room in the house, encompassing the authentic atmosphere of an English cottage. Washed in a minty green, it is ideal for travel buddies from all around.</p>
                        <div className="bottom-specs">
                          <div className="icons">
                            <img src={icon09} alt="gallery" />
                            <img src={icon10} alt="Heater" />
                            <img src={icon03} alt="In-house Dining" />
                            <img src={icon04} alt="Wifi" />
                            <img src={icon07} alt="Television" />
                            <img src={icon11} alt="Hill View" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing" style={{ background: '#ecdfd7' }}>
          <div className="container">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-7">
                <figure className="side-gallery">
                  <div className="reveal-effect"><img src={sideGallery01} alt="gallery4" /></div>
                  <div className="reveal-effect"><img src={sideGallery02} alt="gallery4" /></div>
                  <div className="reveal-effect"><img src={sideGallery03} alt="gallery4" /></div>
                </figure>
              </div>
              <div className="col-lg-5">
                <div className="side-content text-center paddingacom">
                  <h2>Escapes at Kent</h2>
                  <p>For those pursuing those elusive pleasures of peace and quiet, exquisite rooms for the ultimate in comfort, Kent Cottage promises Exclusive Privacy.</p>
                  <a href="https://live.ipms247.com/booking/book-rooms-kentcottagenuwaraeliya" className="custom-button">BOOK OUR VILLA</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing desktopview" style={{ background: '#905d5f' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bar">
                  <i className="lni lni-protection"></i>
                  <h6>View our reviews from our previous guest on</h6>
                  <a href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905" target="_blank" rel="noreferrer">
                    <strong style={{ color: '#fff' }}>Tripadvisor</strong>
                  </a>
                  <figure>
                    <a href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905" target="_blank" rel="noreferrer">
                      <img src={logoTripadviser} alt="Tripadvisor reviews of Kent Cottage" />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <style>
        {`
          .page-header {
            position: relative;
            height: 60vh;
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: left;
            color: white;
          }

          .page-header .container {
            padding: 20px;
            max-width: 1200px;
            margin: 0 auto;
          }

          .page-header .container h1 {
            width: 100%;
            display: block;
            font-size: 48px;
            font-weight: 300;
            margin-bottom: 10px;
            line-height: 1.2;
            font-family: "Argesta Display";
            text-indent: 130px;
          }

          .page-header .container p {
            font-size: 22px;
            font-weight: 300;
            margin: 0;
            line-height: 1.5;
            text-indent: 130px;
          }

          .scroll-down {
            position: absolute;
            bottom: 20px;
            width: 2px;
            height: 40px;
            background: white;
            margin: 0 auto;
            left: 50%;
            transform: translateX(-50%);
          }

          .room-box h3 a {
            font-family: "Argesta Display";
            font-style: normal;
            font-weight: 500;
            color: rgb(114, 38, 40);
            font-size: 36px;
            line-height: 43px;
            text-decoration: none;
          }

          @media (max-width: 768px) {
            .page-header {
              height: 60vh;
              background-size: cover !important;
              background-position: center;
            }

            .page-header .container h1 {
              font-size: 24px;
              line-height: 1.2;
              text-indent: 45px;
            }

            .page-header .container p {
              font-size: 0.9rem;
              line-height: 1.5;
              text-indent: 45px;
            }

            .room-box h3 a {
              font-size: 24px;
              line-height: 30px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Accommodation;